import React, { useState } from 'react';
import { questions } from '../data/questions';
import SearchBar from './SearchBar';
import QuestionList from './QuestionList';
import Pagination from './Pagination';
import { Link } from 'react-router-dom';  // Using Link for routing
import Header from './Header';
import NavBar from './NavBar';

const Home = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredQuestions, setFilteredQuestions] = useState(questions);

    const perPage = 5;

    const filterQuestions = query => {
        setSearchQuery(query);
        const filtered = questions.filter(question =>
            question.q.toLowerCase().includes(query.toLowerCase())
        );
        setFilteredQuestions(filtered);
        setCurrentPage(1); // Reset to the first page on search
    };

    const totalPages = Math.ceil(filteredQuestions.length / perPage);

    const currentQuestions = filteredQuestions.slice(
        (currentPage - 1) * perPage,
        currentPage * perPage
    );

    return (
        <div className="app">
           <Header/>
            <NavBar/>
            <blockquote>
                "I’ve been there—faced rejection, felt the pressure, and stumbled through interviews. This book is for anyone ready to keep pushing forward."
            </blockquote>

            <SearchBar onSearch={filterQuestions} />

            {currentQuestions.length === 0 ? (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <h3>No questions found!</h3>
                    <p>Try adjusting your search query or check back later.</p>
                </div>
            ) : (
                <QuestionList questions={currentQuestions} />
            )}


            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={page => setCurrentPage(page)}
            />
        </div>
    );
};

export default Home;
